import { extend, size } from 'underscore';
import { PageReady } from '@bingads-webui/page-ready';

// Only log the navigation timing info for first grid data load for Grid performance measurement during page load.
let isInitialGridDataLoad = true;
let isPageReadyFulfilled = false;

PageReady.afterPageReady().then(() => {
  isPageReadyFulfilled = true;
});

export function perfMarkerMiddlewareFactory(perfMarker, gridName) {
  const logNavTiming = isInitialGridDataLoad;
  isInitialGridDataLoad = false;

  let isDataLoaded = false;

  let gridMarker = perfMarker.createChild(`cdl-${gridName}-load`);
  gridMarker.willInit();

  return function perfMarkerMiddleware(action, state) {
    const { type } = action;
    if (type === 'START_LOAD_DATA') {
      // If grid marker is already marked done
      // then it means this grid load is from some action on grid
      // actions like, sort, filter, column selection etc.
      // Create a new marker under parent in that case to capture user action.
      if (gridMarker && gridMarker.isDone && gridMarker.parentMarker) {
        gridMarker = gridMarker.parentMarker.createChild(`cdl-${gridName}-action`);
        gridMarker.willInit();
      }

      gridMarker.willFetchData();
      gridMarker.parentMarker.willFetchData();
    } else if (type === 'FINISH_LOAD_DATA') {
      isDataLoaded = true;
      gridMarker.willRender();
      gridMarker.parentMarker.willRender();
    } else if (type === 'TABLE_DID_UPDATE') {
      if (isDataLoaded) {
        const payload = {
          Version: 'campaign-details-list@1.0.0',
          GridName: gridName,
          IsPageReadyFulfilled: isPageReadyFulfilled,
          // IsVirtualized: TODO
          TotalRows: size(state.items),
          TotalServerSideRows: state.totalCount,
          // TotalVisibleRows: TODO
          TotalColumns: state.selectedColumns.length,
        };

        if (logNavTiming) {
          // Add navigation timing info to indicate this is first Grid load
          extend(payload, {
            PageNavStartTime: performance.timing.navigationStart,
            PageFetchStartTime: performance.timing.fetchStart,
            LandingPageUrl: location.href, // TODO: is there a better way to get it?
          });
        }

        gridMarker.done(JSON.stringify(payload));

        isDataLoaded = false;
      }
    }
  };
}
